export const GET_COMMISSION_RULES_REQUEST = 'GET_COMMISSION_RULES_REQUEST';
export const GET_COMMISSION_RULES_DONE = 'GET_COMMISSION_RULES_DONE';
export const GET_COMMISSION_RULES_FAILED = 'GET_COMMISSION_RULES_FAILED';

export const CREATE_COMMISSION_RULE_REQUEST = 'CREATE_COMMISSION_RULE_REQUEST';
export const CREATE_COMMISSION_RULE_DONE = 'CREATE_COMMISSION_RULE_DONE';
export const CREATE_COMMISSION_RULE_FAILED = 'CREATE_COMMISSION_RULE_FAILED';

export const UPDATE_COMMISSION_RULE_REQUEST = 'UPDATE_COMMISSION_RULE_REQUEST';
export const UPDATE_COMMISSION_RULE_DONE = 'UPDATE_COMMISSION_RULE_DONE';
export const UPDATE_COMMISSION_RULE_FAILED = 'UPDATE_COMMISSION_RULE_FAILED';

export const DELETE_COMMISSION_RULE_REQUEST = 'DELETE_COMMISSION_RULE_REQUEST';
export const DELETE_COMMISSION_RULE_DONE = 'DELETE_COMMISSION_RULE_DONE';
export const DELETE_COMMISSION_RULE_FAILED = 'DELETE_COMMISSION_RULE_FAILED';

export const REORDER_COMMISSION_RULE_REQUEST = 'REORDER_COMMISSION_RULE_REQUEST';
export const REORDER_COMMISSION_RULE_DONE = 'REORDER_COMMISSION_RULE_DONE';
export const REORDER_COMMISSION_RULE_FAILED = 'REORDER_COMMISSION_RULE_FAILED';

export const CLEAR_COMMISSION_RULE_ERRORS = 'CLEAR_COMMISSION_RULE_ERRORS';
